import React, { useState } from 'react'
import PropTypes from 'prop-types'
import HippaIconSection from '@Components/Common/HippaIconSection';
import EmployesStyle from './Employers.style';
import { LeftRightDesginIcon, LinkAnchor, refferalRouting } from '@Components/Common/CommonMethods';
import { useRouter } from 'next/router';
import ProfessionalRetailerPopup from '@PagesComponent/Professional_RetailerPopup';
import { useRef } from 'react';
import { useEffect } from 'react';
const Employes = (props) => {
    const router = useRouter();

    const [show, setShow] = useState(false);

    function handleOpenPopup() {
        document.body.classList.add('professional_retailer_form_popup');
        setShow(true);
    }

    const ref = useRef();
    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (ref.current && !ref.current.contains(e.target)) {

                setShow(false);
                document.body.classList.remove('professional_retailer_form_popup');
                // console.log('outside');
                //   onClose()
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [show])
    return (
        <EmployesStyle>
            <div className='main_employes_section' ref={ref}>
                <LeftRightDesginIcon>
                    <div className='title_sections'>
                        <h2>Employers</h2>
                        <h3>Innovative Employee Wellness With Real Impact.</h3>
                    </div>
                    <div className='text_container'>
                        <div className='container'>
                            <div className='d-flex row'>
                                <div className='col-md-6'>
                                    <div className='first_content_section'>

                                        <p>
                                            Backed by over thirty years of research, our DNA-based,
                                            precision nutrition is a simple solution to advancing
                                            employee health.
                                        </p>
                                        <p>Employers win when their employees are well.</p>
                                        <div className='content-area'>
                                            <p>
                                                According to a 2022 article by Zippia, employers can
                                                expect to see high returns on investments made in holistic
                                                employee programs:
                                            </p>
                                            <ul>
                                                <li>
                                                    Reduced costs. 72% of employers say employee
                                                    wellness programs reduce healthcare costs.
                                                </li>
                                                <li>
                                                    Increased productivity. 60% of employees who
                                                    participate in wellness programs report higher
                                                    productivity.
                                                </li>
                                                <li>
                                                    Increased performance. 84% of employers say that
                                                    wellness programs lead to increased employee
                                                    productivity and performance.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='second_content_section'>
                                        <div className='message_tip'>
                                            <div className='image'>
                                                <img src="/images/green-bg.png" />
                                            </div>
                                            <div className='content-quote'>
                                                <p>
                                                    "Wellness is important in the workplace
                                                    because employees need to be healthy to be
                                                    happy and productive. Even the most
                                                    dedicated employee will burn out or get sick if
                                                    they don't take care of themselves, so giving
                                                    them a push to prioritize their wellness can
                                                    help prevent this from happening. In addition,
                                                    lower-performing employees will often
                                                    increase their productivity and engagement
                                                    levels when they're healthy, and showing
                                                    workers that they're cared for will also improve
                                                    performance and work satisfaction.”
                                                </p>
                                                <span>
                                                    <LinkAnchor className="elementor-testimonial-name" href="https://zippia.com" target="_blank">Zippia</LinkAnchor>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='button_sections'>
                            <LinkAnchor href={refferalRouting('/us/employers/employer_form/')}>
                                <button className='learn_more'>LEARN MORE</button>
                            </LinkAnchor>
                            {/*<button className='learn_more' style={{ margin: '10px' }}>
                                <a style={{ color: '#fff' }} href='https://admin.snipnutrition.com/media/documents/SNIP_Affiliate_Document_copy.pdf'
                                    target='_blank'>EMPLOYERS PROGRAM</a>
    </button>*/}
                        </div>
                    </div>
                    {show && <ProfessionalRetailerPopup open={show} setOpen={setShow} section="employes" plan="Employers plan" />}
                    <HippaIconSection />
                </LeftRightDesginIcon>
            </div >
        </EmployesStyle >
    )
}

Employes.propTypes = {}

export default Employes;
